/*
  Combo offer — adds the suggested partner variant to the cart.

  The discount itself is an automatic discount configured in Shopify admin; nothing
  here calculates or applies it. This only posts one unit of the partner variant to
  /cart/add.js and then refreshes whichever cart UI is on screen, using the Section
  Rendering API the same way Dawn's own cart.js and product-form.js do.

  Clicks are delegated from the document so the buttons keep working after Dawn
  replaces the cart or product markup with freshly rendered sections.
*/
(function () {
  'use strict';

  /* The snippet that loads this file can appear more than once on a page (cart page
     plus drawer), so bail out if the delegated listener is already attached. */
  if (window.comboOfferInitialised) return;
  window.comboOfferInitialised = true;

  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : null;
  }

  /* Mirrors CartItems.getSectionsToRender() in cart.js. */
  function getCartPageSections() {
    const items = document.getElementById('main-cart-items');
    if (!items) return null;

    const sections = [
      { id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
    ];

    const footer = document.getElementById('main-cart-footer');
    if (footer) {
      sections.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    }

    return sections;
  }

  /* Mirrors CartDrawerItems.getSectionsToRender() in cart-drawer.js. */
  function getDrawerSections() {
    if (!document.getElementById('CartDrawer')) return null;

    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }

  function applySections(response, sections) {
    sections.forEach((section) => {
      const root = document.getElementById(section.id);
      if (!root || !response.sections) return;

      const markup = response.sections[section.section];
      if (!markup) return;

      const inner = getSectionInnerHTML(markup, section.selector);
      if (inner === null) return;

      const target = root.querySelector(section.selector) || root;
      target.innerHTML = inner;
    });
  }

  function setBusy(button, busy) {
    const label = button.querySelector('.combo-offer-card__button-text');
    const busyLabel = button.querySelector('.combo-offer-card__button-busy');

    if (busy) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    } else {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
    }

    if (label) label.hidden = busy;
    if (busyLabel) busyLabel.hidden = !busy;
  }

  function showError(button, message) {
    const card = button.closest('.combo-offer-card');
    if (!card) return;

    let errorElement = card.querySelector('.combo-offer-card__error');
    if (!errorElement) {
      errorElement = document.createElement('p');
      errorElement.className = 'combo-offer-card__error';
      errorElement.setAttribute('role', 'alert');
      card.appendChild(errorElement);
    }
    errorElement.textContent = message;
  }

  function addPartner(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;

    const variantId = button.dataset.comboVariantId;
    if (!variantId) return;

    const inDrawer = Boolean(button.closest('cart-drawer'));
    const sections = inDrawer ? getDrawerSections() : getCartPageSections();
    const cart = sections ? null : getCartElement();

    const body = { items: [{ id: Number(variantId), quantity: 1 }] };

    if (sections) {
      body.sections = sections.map((section) => section.section);
      body.sections_url = window.location.pathname;
    } else if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    setBusy(button, true);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          throw new Error(response.description || response.message || '');
        }

        if (sections) {
          applySections(response, sections);
        } else if (cart) {
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'combo-offer',
            productVariantId: variantId,
            cartData: response,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        setBusy(button, false);
        showError(button, window.comboOfferStrings ? window.comboOfferStrings.error : '');
      });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-combo-add]');
    if (!button) return;

    event.preventDefault();
    addPartner(button);
  });
})();
